function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "E4H/Onion");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\uD83D\\uDDA5-Wireframes-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: -1438,
  y: -2402,
  width: 4076,
  height: 2568
}), React.createElement("g", {
  id: "E4H/Onion",
  transform: "translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
}, React.createElement("g", {
  id: "Society",
  fill: "#2F6BD2"
}, React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10
})), React.createElement("g", {
  id: "Community-partner",
  transform: "translate(2.000000, 1.000000)",
  fill: "#337348"
}, React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5
})), React.createElement("g", {
  id: "Class",
  transform: "translate(4.000000, 2.000000)",
  fill: "#ED9558"
}, React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5
})), React.createElement("g", {
  id: "Team",
  transform: "translate(5.000000, 3.000000)",
  fill: "#EB8741"
}, React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5
})), React.createElement("g", {
  id: "Student",
  transform: "translate(7.000000, 3.000000)",
  fill: "#E67C2F"
}, React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 3.5
}))));

var SvgOnionSm = function SvgOnionSm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOnionSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onion_sm.bbdc87f1.svg";
export { ForwardRef as ReactComponent };